import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { DEFAULT_LOCALE, resources, SUPPORTED_LOCALES } from './resources'

// V1 = FR uniquement (décision produit 2026-06-14, AC-I01). Le français est la
// source de vérité et le SEUL fallback : toute clé absente résout en FR, jamais
// vers l'`en_US` partiel/figé (conservé pour une future V1.1 bilingue, hors
// chaîne de fallback). Voir mémoire project_i18n_en_parity_conflict.
// Locales dérivées du registre (RV-60-H) : ajout d'une langue = entrée registre,
// aucun changement ici.
void i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  supportedLngs: SUPPORTED_LOCALES,
  interpolation: {
    escapeValue: false,
    // `{{brandName}}` default, overridden once the brand snapshot loads (BrandQueriesProvider) -
    // never hardcode a tenant-specific name, this codebase is reused across CSE instances.
    defaultVariables: { brandName: 'CSE' },
  },
})

export { i18n }
